import React from 'react';
import Radium from '@flipdish/radium';
import * as Api from '../../../Api';
import * as Actions from '../../../actions/Actions';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { getTranslate } from 'react-localize-redux';
import * as Store from '../../../Store';
import { Grid } from '../../../../ui';

const tinycolor = require('tinycolor2');

type InnerProps = MappedProps & MappedDispatch;
type OuterProps = {
  appDesignScheme: Api.AppDesignScheme;
  checkoutState: {
    ChefNote: 'custom' | 'loaded';
    menuLoadState: 'NOT_LOADED' | 'LOADING' | 'LOADED';
    PendingVouchers: any;
    ShowModal: boolean;
    ShowEmailModal: boolean;
    ShowTimeAndNameModal: boolean;
  };
  pickupLocationOptions: Api.PickupLocationOption[];
  pickupLocationType: Api.PickupLocationType;
  tableNumber: number;
  tableServiceCategory: number;
  toggleModal: () => void;
  vrid: number;
  serviceTypes: {
    isDelivery: boolean;
    isDineInAndTakeOut: boolean;
    isDriveThrough: boolean;
    isDriveThroughOnly: boolean;
    isTableServiceAndTakeOut: boolean;
    isTableServiceOnly: boolean;
  };
};

type Props = InnerProps & OuterProps;
const SelectServiceButtons: React.FC<Props> = (props) => {
  const {
    appDesignScheme,
    checkoutState,
    editPickupLocationTypes,
    pickupLocationOptions,
    pickupLocationType,
    tableNumber,
    tableServiceCategory,
    toggleModal,
    translate,
    vrid
  } = props;
  const {
    isDelivery,
    isDineInAndTakeOut,
    isDriveThrough,
    isDriveThroughOnly,
    isTableServiceAndTakeOut,
    isTableServiceOnly
  } = props.serviceTypes;

  const styles = {
    primary: {
      color: appDesignScheme.Primary
    },
    secondary: {
      color: appDesignScheme.Secondary
    },
    buttonPrimary: {
      backgroundColor: tinycolor(appDesignScheme.Primary)
        .darken(3)
        .toString(),
      borderColor: appDesignScheme.Secondary,
      ':hover': {
        borderColor: appDesignScheme.Secondary
      },
      ':active': {},
      ':focus': {
        borderColor: appDesignScheme.Secondary
      }
    },
    buttonActive: {
      backgroundColor: tinycolor(appDesignScheme.Secondary)
        .darken(10)
        .toString()
    },
    buttonHover: {
      backgroundColor: tinycolor(appDesignScheme.Secondary)
        .darken(5)
        .toString()
    },
    buttonPrimaryHover: {
      backgroundColor: appDesignScheme.Secondary
    },
    buttonSecondary: {
      backgroundColor: appDesignScheme.Secondary,
      ':hover': {},
      ':active': {},
      ':focus': {}
    }
  };

  const renderButtonText = () => {
    switch (tableServiceCategory) {
      case Api.TableServiceCategory.Gate:
        return translate('Gate_delivery');
      case Api.TableServiceCategory.DriveThrough:
        return translate('Drive_Through');
      default:
        return translate('Dine_in');
    }
  };

  const renderButtonSubtext = () => {
    if (isDriveThrough) {
      return translate('Pick_up_at_drive_through');
    }

    if (typeof tableNumber !== 'number') {
      return translate(`Select_table_${tableServiceCategory}`);
    }

    if (pickupLocationOptions) {
      return (
        pickupLocationOptions.find((option) => option.PickupLocationOptionId === tableNumber)
          .Value || `${translate(`Table_${tableServiceCategory}`)} ${tableNumber}`
      );
    }
    return `${translate(`Table_${tableServiceCategory}`)} ${tableNumber}`;
  };

  if (isDelivery || isDriveThroughOnly) {
    return null;
  }

  if (isTableServiceOnly) {
    return (
      <Grid item xs={12}>
        <button
          className="checkout__select-table fd-button fd-button--big fd-button--primary flex flex-align-center flex-justify-center block-center"
          onClick={toggleModal}
          key="table-select-button"
          style={
            [
              styles.buttonPrimary,
              Radium.getState(checkoutState, 'table-select-button', ':active')
                ? styles.buttonActive
                : Radium.getState(checkoutState, 'table-select-button', ':hover')
                ? styles.buttonPrimaryHover
                : null
            ] as any
          }
        >
          <p
            className="clear-margins secondary fd-h4"
            style={
              Radium.getState(checkoutState, 'table-select-button', ':hover') ||
              Radium.getState(checkoutState, 'table-select-button', ':active')
                ? styles.primary
                : styles.secondary
            }
          >
            {renderButtonSubtext()}
          </p>
        </button>
      </Grid>
    );
  }

  if (isDineInAndTakeOut) {
    return (
      <Grid item xs={12}>
        <div
          className="flex checkout__options"
          style={{
            marginBottom: 0
          }}
        >
          <button
            className={`fd-button fd-button--big fd-button--${
              pickupLocationType === Api.PickupLocationType.DineIn ? 'secondary' : 'primary'
            } flex flex-align-center flex-justify-center flex-one`}
            onClick={() => {
              editPickupLocationTypes(vrid, Api.PickupLocationType.DineIn);
            }}
            key="table-select-button"
            style={
              [
                pickupLocationType === Api.PickupLocationType.DineIn
                  ? styles.buttonSecondary
                  : styles.buttonPrimary,
                Radium.getState(checkoutState, 'table-select-button', ':active')
                  ? styles.buttonActive
                  : Radium.getState(checkoutState, 'table-select-button', ':hover')
                  ? pickupLocationType === Api.PickupLocationType.DineIn
                    ? styles.buttonHover
                    : styles.buttonPrimaryHover
                  : null
              ] as any
            }
          >
            <p
              className={`clear-margins fd-h4 ${
                pickupLocationType === Api.PickupLocationType.DineIn ? 'primary' : 'secondary'
              }`}
              style={
                pickupLocationType === Api.PickupLocationType.DineIn
                  ? styles.primary
                  : Radium.getState(checkoutState, 'table-select-button', ':hover') ||
                    Radium.getState(checkoutState, 'table-select-button', ':active')
                  ? styles.primary
                  : styles.secondary
              }
            >
              {renderButtonText()}
            </p>
          </button>
          <button
            className={`fd-button fd-button--big fd-button--${
              pickupLocationType === Api.PickupLocationType.TakeOut ? 'secondary' : 'primary'
            } flex flex-align-center flex-justify-center flex-one`}
            onClick={() => {
              editPickupLocationTypes(vrid, Api.PickupLocationType.TakeOut);
            }}
            key="table-select-button-two"
            style={
              [
                pickupLocationType === Api.PickupLocationType.TakeOut
                  ? styles.buttonSecondary
                  : styles.buttonPrimary,
                Radium.getState(checkoutState, 'table-select-button-two', ':active')
                  ? styles.buttonActive
                  : Radium.getState(checkoutState, 'table-select-button-two', ':hover')
                  ? pickupLocationType === Api.PickupLocationType.DineIn
                    ? styles.buttonHover
                    : styles.buttonPrimaryHover
                  : null
              ] as any
            }
          >
            <p
              className={`clear-margins fd-h4 ${
                pickupLocationType === Api.PickupLocationType.TakeOut ? 'primary' : 'secondary'
              }`}
              style={
                pickupLocationType === Api.PickupLocationType.TakeOut
                  ? styles.primary
                  : Radium.getState(checkoutState, 'table-select-button-two', ':hover') ||
                    Radium.getState(checkoutState, 'table-select-button-two', ':active')
                  ? styles.primary
                  : styles.secondary
              }
            >
              {translate('Take_out')}
            </p>
          </button>
        </div>
      </Grid>
    );
  }

  if (isTableServiceAndTakeOut) {
    return (
      <Grid item xs={12}>
        <div
          className="flex checkout__options"
          style={{
            marginBottom: 0
          }}
        >
          <button
            className={`fd-button fd-button--big fd-button--${
              pickupLocationType === Api.PickupLocationType.TableService ? 'secondary' : 'primary'
            } flex flex-align-center flex-justify-center flex-one`}
            onClick={() => {
              editPickupLocationTypes(vrid, Api.PickupLocationType.TableService);
              if (!isDriveThrough) {
                toggleModal();
              }
            }}
            key="table-select-button"
            style={
              [
                pickupLocationType === Api.PickupLocationType.TableService
                  ? styles.buttonSecondary
                  : styles.buttonPrimary,
                Radium.getState(checkoutState, 'table-select-button', ':active')
                  ? styles.buttonActive
                  : Radium.getState(checkoutState, 'table-select-button', ':hover')
                  ? pickupLocationType === Api.PickupLocationType.TableService
                    ? styles.buttonHover
                    : styles.buttonPrimaryHover
                  : null
              ] as any
            }
          >
            <p
              className={`clear-margins fd-h5 ${
                pickupLocationType === Api.PickupLocationType.TableService ? 'primary' : 'secondary'
              }`}
              style={
                pickupLocationType === Api.PickupLocationType.TableService
                  ? styles.primary
                  : Radium.getState(checkoutState, 'table-select-button', ':hover') ||
                    Radium.getState(checkoutState, 'table-select-button', ':active')
                  ? styles.primary
                  : styles.secondary
              }
            >
              {renderButtonText()}
            </p>
            <p
              className={`clear-margins fd-h4 ${
                pickupLocationType === Api.PickupLocationType.TableService ? 'primary' : 'secondary'
              }`}
              style={
                pickupLocationType === Api.PickupLocationType.TableService
                  ? styles.primary
                  : Radium.getState(checkoutState, 'table-select-button', ':hover') ||
                    Radium.getState(checkoutState, 'table-select-button', ':active')
                  ? styles.primary
                  : styles.secondary
              }
            >
              {renderButtonSubtext()}
            </p>
          </button>
          <button
            className={`fd-button fd-button--big fd-button--${
              pickupLocationType === Api.PickupLocationType.TakeOut ? 'secondary' : 'primary'
            } flex flex-align-center flex-justify-center flex-one`}
            onClick={() => {
              editPickupLocationTypes(vrid, Api.PickupLocationType.TakeOut);
            }}
            key="table-select-button-two"
            style={
              [
                pickupLocationType === Api.PickupLocationType.TakeOut
                  ? styles.buttonSecondary
                  : styles.buttonPrimary,
                Radium.getState(checkoutState, 'table-select-button-two', ':active')
                  ? styles.buttonActive
                  : Radium.getState(checkoutState, 'table-select-button-two', ':hover')
                  ? pickupLocationType === Api.PickupLocationType.DineIn
                    ? styles.buttonHover
                    : styles.buttonPrimaryHover
                  : null
              ] as any
            }
          >
            <p
              className={`clear-margins fd-h5 ${
                pickupLocationType === Api.PickupLocationType.TakeOut ? 'primary' : 'secondary'
              }`}
              style={
                pickupLocationType === Api.PickupLocationType.TakeOut
                  ? styles.primary
                  : Radium.getState(checkoutState, 'table-select-button-two', ':hover') ||
                    Radium.getState(checkoutState, 'table-select-button-two', ':active')
                  ? styles.primary
                  : styles.secondary
              }
            >
              {translate('Take_out')}
            </p>
            <p
              className={`clear-margins fd-h4 ${
                pickupLocationType === Api.PickupLocationType.TakeOut ? 'primary' : 'secondary'
              }`}
              style={
                pickupLocationType === Api.PickupLocationType.TakeOut
                  ? styles.primary
                  : Radium.getState(checkoutState, 'table-select-button-two', ':hover') ||
                    Radium.getState(checkoutState, 'table-select-button-two', ':active')
                  ? styles.primary
                  : styles.secondary
              }
            >
              {translate('Collect_counter')}
            </p>
          </button>
        </div>
      </Grid>
    );
  }

  return null;
};

type MappedProps = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: WebOrder.State) => {
  return { translate: getTranslate(state.locale) };
};

type MappedDispatch = ReturnType<typeof mapDispatchToProps>;
const mapDispatchToProps = (dispatch: ThunkDispatch<Store.State, {}, Action>) => {
  return {
    editPickupLocationTypes: (vrid: number, value: Api.PickupLocationType) => {
      dispatch(Actions.EditPickupLocationTypes(vrid, value));
    }
  };
};

export default compose<InnerProps, OuterProps>(connect(mapStateToProps, mapDispatchToProps))(
  Radium(SelectServiceButtons)
);
